import { z } from 'zod'
import type { Customer } from '#/domain/customerAccess/Customer'
import type { CustomerDto as CustomerDtoSpec } from '#/infrastructure/api/generated'
import type { Assert, SpecContract } from '#/infrastructure/api/SpecContract'

export const CustomerDtoSchema = z
  .object({
    Id: z.string(),
    Name: z.string(),
    DisplayName: z.string(),
  })
  .transform((raw): Customer => ({
    Id: raw.Id,
    Name: raw.Name,
    DisplayName: raw.DisplayName,
  }))

export type CustomerResponseDto = z.input<typeof CustomerDtoSchema>
export type CustomerDtoSpecContract = Assert<SpecContract<CustomerResponseDto, CustomerDtoSpec>>

export function toDomain(raw: CustomerResponseDto): Customer {
  return CustomerDtoSchema.parse(raw)
}

export function toDomainList(raw: CustomerResponseDto[]): Customer[] {
  return raw.map(toDomain)
}
